import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
@Injectable()
export class DmpApiHttpInterceptor implements HttpInterceptor {
  constructor(@Inject(PLATFORM_ID) private platformId) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const dmpServerUrl = "https://dmp.airiane.com/services";
    let path = null;
    if(isPlatformBrowser(this.platformId) && sessionStorage.overrideDmpUrl){
      path = sessionStorage.overrideDmpUrl;
    }
    if(path && path.length > 0 && request.url.startsWith(dmpServerUrl)){
      let newUrl = request.url.replace(dmpServerUrl, path);
      request = request.clone({
        url: newUrl
      });
    }
    return next.handle(request);
  }
}